import { createSlice } from '@reduxjs/toolkit';
import API from 'api/index.js';

const initialState = {
    users: [],
    shops: [],
    isUsersCollapsed: false,
    isStationsCollapsed: true,
    isCompaniesCollapsed: true,
};

export const operatorUserManagementSlice = createSlice({
    name: 'operatorUserManagement',
    initialState,
    reducers: {
        setIsUsersCollapsed: (state, { payload }) => { state.isUsersCollapsed = payload; },
        setIsStationsCollapsed: (state, { payload }) => { state.isStationsCollapsed = payload; },
        setIsCompaniesCollapsed: (state, { payload }) => { state.isCompaniesCollapsed = payload; },
    },
    extraReducers: builder => {
        const {
            operatorUserList,
            shopContractorUserList,
            operatorShopList,
            operatorUserCreate,
            shopContractorUserCreate,
            operatorUserSingleUpdate,
            shopContractorUserUpdate,
            operatorUserDelete,
            shopContractorUserDelete,
            operatorShopSingleUpdate,
            operatorShopSingleDelete,
            operatorShopCreate,
        } = API.endpoints;

        builder
            .addMatcher(operatorUserList.matchFulfilled, (state, { payload }) => { state.users = payload; })
            .addMatcher(shopContractorUserList.matchFulfilled, (state, { payload }) => { state.users = payload; })
            .addMatcher(operatorUserCreate.matchFulfilled, (state, { payload }) => { state.users.push(payload); })
            .addMatcher(shopContractorUserCreate.matchFulfilled, (state, { payload }) => { state.users.push(payload); })
            .addMatcher(operatorUserSingleUpdate.matchFulfilled, (state, { payload }) => {
                const i = state.users.findIndex(user => user.id === payload.id);
                if(i !== -1) state.users[i] = payload;
            })
            .addMatcher(shopContractorUserUpdate.matchFulfilled, (state, { payload }) => {
                const i = state.users.findIndex(user => user.id === payload.id);
                if(i !== -1) state.users[i] = payload;
            })
            .addMatcher(operatorUserDelete.matchFulfilled, (state, { meta: { arg: { originalArgs } } }) => {
                const i = state.users.findIndex(user => user.id === originalArgs);
                if(i !== -1) state.users.splice(i, 1);
            })
            .addMatcher(shopContractorUserDelete.matchFulfilled, (state, { meta: { arg: { originalArgs } } }) => {
                const i = state.users.findIndex(user => user.id === originalArgs);
                if(i !== -1) state.users.splice(i, 1);
            })
            .addMatcher(operatorShopList.matchFulfilled, (state, { payload }) => { state.shops = payload; })
            .addMatcher(operatorShopCreate.matchFulfilled, (state, { payload }) => { state.shops.push(payload); })
            .addMatcher(operatorShopSingleUpdate.matchFulfilled, (state, { payload }) => {
                const i = state.shops.findIndex(shop => shop.id === payload.id);
                if(i !== -1) state.shops[i] = payload;
            })
            .addMatcher(operatorShopSingleDelete.matchFulfilled, (state, { meta: { arg: { originalArgs } } }) => {
                const i = state.shops.findIndex(shop => shop.id === originalArgs);
                if(i !== -1) state.shops.splice(i, 1);
            });
    },
});

export const {
    setIsUsersCollapsed,
    setIsStationsCollapsed,
    setIsCompaniesCollapsed,
} = operatorUserManagementSlice.actions;

export default operatorUserManagementSlice.reducer;
